module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAKlBMVEUAAADu7u7u7u7dLkTu7u7u7u7dLkTdLkTdLkTdLkTu7u7u7u7dLkQ7iMNkA1kjAAAAC3RSTlMAv88gIGC/YM/v7221RzMAAABoSURBVHja7dCJCcAwDEPR3Jfb/ddtYrqBRSlGf4CHUGDMbTWKoVhfpiQxlopCS8wtlQRQQkFSUVBEQUKI0N+gGxIhQoQIEfoCuiARIuQSaiiog6ARdtPuzHygPMx7tqP1Zvq5B8b89gBhjaojiaQoZAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1f7-1f1fa.png
// module id = 611
// module chunks = 0